import api from '../api';

const TOKEN_KEY = 'qmatch-matcher-app-token'

/**
 * Authenticate the user, get the token from the backend and store it
 * in the `localStorage`. 
 * 
 * @param {String} email
 * @param {String} password
 */
export function authenticate(email, password) {
  return api.auth.authenticate(email, password).then(setToken)
}


/**
 * Check if the user is authenticated.
 * 
 * It will check if we have a token present in the `localStorage`.
 * 
 * @returns {Boolean} indicating if the user is authenticated or not.
 */
export function isAuthenticated() {
  return !!getToken()
}


/**
 * Get the token from the `localStorage`.
 */
export function getToken() {
  return window.localStorage.getItem(TOKEN_KEY)
}


/**
 * Set the auth token in the `localStorage`.
 *
 * @param {String} token
 */
function setToken(token) {
  return window.localStorage.setItem(TOKEN_KEY, token)
}


/**
 * Simple remove the token from the local storage.
 */
export function logout() {
  return window.localStorage.removeItem(TOKEN_KEY)
}


export default {
  authenticate,
  isAuthenticated,
  getToken,
  logout
}